import { CircularProgress, TextField } from "@material-ui/core";
import * as React from "react";
import { useGroopitApiContext } from "groopit-js";
import { TeamsChannelDTO } from "groopit-js";
import { Autocomplete } from "@material-ui/lab";

interface TeamsChannelSelectorProps {
  connectionId: string;
  excludedChannels: string[];
  onChannelSelected: (channel: TeamsChannelDTO | null) => void;
}

export const TeamsChannelSelector = (
  props: TeamsChannelSelectorProps,
): JSX.Element => {
  const api = useGroopitApiContext();
  const [channels, setChannels] = React.useState<TeamsChannelDTO[]>();
  const [selectedChannel, setSelectedChannel] =
    React.useState<TeamsChannelDTO | null>(null);

  React.useEffect(() => {
    props.onChannelSelected(selectedChannel);
  }, [selectedChannel]);

  React.useEffect(() => {
    if (
      selectedChannel &&
      props.excludedChannels.includes(selectedChannel.channelId)
    ) {
      setSelectedChannel(null);
    }
    setChannels(
      [...(channels ?? [])].filter(
        (c) => props.excludedChannels.indexOf(c.channelId) === -1,
      ),
    );
  }, [props.excludedChannels]);

  React.useEffect(() => {
    api.teams
      .getUserChannels(props.connectionId)
      .then((channels) => {
        setChannels(
          channels.filter(
            (c) => props.excludedChannels.indexOf(c.channelId) === -1,
          ),
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      {channels ? (
        <>
          <Autocomplete
            loading
            renderInput={(params) => (
              <TextField {...params} label="Select Teams Channel:" />
            )}
            getOptionLabel={(channel) =>
              `${channel.teamName} > ${channel.channelName}`
            }
            clearOnBlur={false}
            value={selectedChannel}
            onChange={(event, value) => setSelectedChannel(value)}
            noOptionsText="No Results"
            options={channels}
          />
        </>
      ) : (
        <div className="text-center mt-8">
          <CircularProgress />
        </div>
      )}
    </>
  );
};
